import { Button } from "antd";
import TableHeadComponent from "../../../../elements/TableHeadComponent";

const TableHead = ({ children }) => {
  return <TableHeadComponent>{children}</TableHeadComponent>;
};

export default TableHead;
